<template>

    <div class="wrapper-main page-container">

        <header-band
                :title="$t('login_email_web_header')"
                :blueCleanfox="true"
                :back="true"
                @eventBack="back"
        ></header-band>

        <login :emailProps="loginEmail"></login>

    </div>

</template>

<script>

    import Vuex from 'vuex'

    import InputText from "@/components/inputs/InputText"
    import Login from "@/components/loginFlow/Login"
    import HeaderBand from '@/components/headers/HeaderBand'

    import Storage from '@/helpers/storage'
    import UserFlow from '@/modules/userFlow'

    export default {

        name: 'login-page',

        components: {InputText, Login, HeaderBand},

        computed: {

            ...Vuex.mapGetters(['loginEmail'])

        },

        data() {

            return {
                provider: ''
            }

        },

        created() {

            UserFlow.setPage(this, 'login')

        },

        mounted() {

            if (this.$route.params && this.$route.params.provider) {

                this.provider = this.$route.params.provider

            }

        },

        methods: {

            back() {

                if (Storage.getItem('token')) {

                    this.$router.push({path: '/add-inbox'})

                } else {

                    this.$router.push({path: '/'})

                }
            }
        }
    }

</script>

<style scoped lang="scss">

    .page-container {
        @media screen and (min-width: $above-tablet-length) {
            background-color: $timberwolf;
            display: flex;
            align-items: center;
            flex-direction: column;
        }
    }

</style>
